import EasyPlanClient from './EasyPlanClient';
import router from "../router/index";
import LoginOwnerCopyVue from '@/views/LoginOwner copy.vue';
var isRefreshingToken = false;
export default {
    loginTime: null,
    loginTimeout: 1000 * 60 * 60 * 2,
    loadCompanyInfo(companyAlias, callback = () => { }) {
        console.debug("carico companyInfo");
        var sh = this;
        EasyPlanClient.Company.FindByAlias(companyAlias)
            .then((res) => {
                console.debug(res);
                console.debug(this.companyInfo);
                sh.setCompanyInfo(res.data.data)
                callback(res.data.data);
            })
            .catch((error) => {
                console.log(error);
                this.error = EasyPlanClient.GetErrorDescription(
                    error.response.data.errorCode
                );
                console.error(
                    "si è verificato un errore (" +
                    error.response.data.errorCode +
                    ")" +
                    this.error
                );
                console.error(error);
            });
    },
    Logoff(companyAlias, callback = () => { }) {
        console.debug("logging off");
        localStorage.userToken = null;
        localStorage.currentUser = null;
        localStorage.currentCompany = null;
        callback();
        if (companyAlias) {
            router.push({
                name: "login",
                params: { companyAlias: companyAlias },
            });
        }
        else {
            router.push({
                name: "login-owner"
            });
        }

    },
    isRefreshingToken:false,
    RefreshToken() {
        let sh = this;
        if (!sh.isRefreshingToken) {
            sh.isRefreshingToken = true;
            console.debug("refresh   token in corso")
            let usr = sh.getCurrentUser();
            if(usr!=null){
                let token = usr.token;
                console.debug("vecchio token:", token);
                let companyInfo = sh.getCompanyInfo();
                let companyAlias = companyInfo.alias;
                  
                
                
                EasyPlanClient.User.RefreshToken(token, companyAlias).then((res) => { 
                    console.debug("  token res:", res );
                    if (res?.data?.data) {
                        console.debug("nuovo token:", res.data.data);
                        EasyPlanClient.SetJWT(res.data.data);
                        localStorage.userToken = res.data.data;
                        usr.token = localStorage.userToken;
                        sh.setCurrentUser(usr);
                        console.debug("TOKEN AGGIORNATO");
                    }
                    else {
                        console.error("ERRORE REFRESH TOKEN");
                    }
    
                    isRefreshingToken = false;
                })
                    .catch((error) => {
                        try{
                            isRefreshingToken = false;
                            sh.error = EasyPlanClient.GetErrorDescription(
                                error.response.data.errorCode
                            );
                            // alert(
                            //     "Il tuo account non è stato verificato. Esegui accesso di nuovo e verifica account."
                            // );
                            // sh.$router.push("/");
                            console.error(
                                "si è verificato un errore (" +
                                error.response.data.errorCode +
                                ")" +
                                sh.error
                            );
                            console.error(error);
                        }
                        catch(err){
                                console.error(err);
                        }
                       
                    });
            }
            else{
                console.debug("REFRESH TOKEN NON ESEGUITO PERCHE UTENTE NON LOGGATO");
            }
            
        }
        else {
            console.debug("REFRESH TOKEN NON ESEGUITO PERCHE' IN CORSO UN'ALTRA RICHIESTA");
        }


    },
    IsSessionValid() {

        if (localStorage.loginTime) {
            console.debug("llocalStorage.loginTime", localStorage.loginTime);
            this.loginTime = JSON.parse(localStorage.loginTime);
            console.debug("this.loginTime", this.loginTime);
            console.debug("this.loginTimeout", this.loginTimeout);
            console.debug("new Date()- this.loginTime", new Date().getTime() - this.loginTime);
            return (new Date().getTime() - this.loginTime) < this.loginTimeout;
        }
        return false;
    },
    getCurrentUser() {

        if (localStorage.currentUser != null) {
            let user = JSON.parse(localStorage.currentUser);
            return user;
        }
        else return null;
    },
    getCompanyInfo() {

        if (localStorage.currentUser != null) {
            let companyInfo = JSON.parse(localStorage.companyInfo);
            return companyInfo;
        }
        else return null;
    },
    setCurrentUser(user) {

        localStorage.currentUser = JSON.stringify(user);
    },
    setCompanyInfo(companyInfo) {

        localStorage.companyInfo = JSON.stringify(companyInfo);
    },
    checkPermission(permission) {
        let allowed = false;
        let user=this.getCurrentUser();
        if (user != null && user!=undefined) { 
            //console.debug("currentUser", user);
            if (user.idRuolo == 1) { //OWNER
                allowed = true;
            }
            else if (user.ruolo != null) {

                //console.debug("ruolo", user.ruolo);
                if (user.ruolo.permessi != null) {
                    //console.debug("permessi", user.ruolo.permessi);
                    allowed = (user.ruolo.permessi.filter(p => p.idPermesso == permission && p.abilitato)).length > 0
                }
            }
        }


        return allowed;
    },
    checkRedirects(companyAlias) {
        if (!this.IsSessionValid()) {
            this.Logoff(companyAlias);
            router.push({
                name: "login",
                params: { companyAlias: companyAlias },
            });
        }
        else if (!this.checkPermission("SHOW_SIDEBAR"))
            router.push({
                name: "agenda-viewer",
                params: { companyAlias: companyAlias },
            });
    },
    refreshSessionActive: false,
    activateRefreshSession() {
        if (this.checkPermission("UNLIMITED_SESSION") && !this.refreshSessionActive) {
            this.refreshSessionActive = true;
            console.debug("Attivo refresh automatico token")
            let sh = this;
            setInterval(() => {
                if (!sh.isRefreshingToken)
                    sh.RefreshToken();
                else
                    console.debug("refresh token saltato perchè è in corso un altra richiesta 1");
            }, 120000);
        }
        else {

            console.debug("refresh automatico token non attivo");
        }
    },
    loadUserInfo(companyAlias, callback = () => { }) {
        console.debug("carico companyInfo");

        EasyPlanClient.User.Find(companyAlias, "current")
            .then((res) => {
                console.debug(res);
                this.loginTime = new Date().getTime();
                localStorage.loginTime = JSON.stringify(this.loginTime);
                // this.currentUser = res.data.data;
                localStorage.currentUser = JSON.stringify(res.data.data);
                console.debug(this.companyInfo);

                this.activateRefreshSession(localStorage.currentUser);
                callback(res.data.data);
            })
            .catch((error) => {
                console.log(error);
                this.error = EasyPlanClient.GetErrorDescription(
                    error.response.data.errorCode
                );
                console.error(
                    "si è verificato un errore (" +
                    error.response.data.errorCode +
                    ")" +
                    this.error
                );
                console.error(error);
            });
    }
}